import React from "react";
import { defineMessages, useIntl } from "react-intl";
import { commonMessages } from "../../../../../../../utils/messages";
import ContainerBlock from "../../../../Components/ContainerBlock/ContainerBlock";

const EmptyState = () => {
    const intl = useIntl();

    return (
        <ContainerBlock>
            <h3>
                {"0 "}
                {intl.formatMessage(commonMessages.student).toLowerCase()}
            </h3>
            <p>{intl.formatMessage(messages.createStudent)}</p>
        </ContainerBlock>
    );
};
export default EmptyState;

const messages = defineMessages({
    createStudent: {
        id: "workmode-playlist-createStudentToAddToRecipients",
        defaultMessage:
            "You don't have any students yet. You can create classes and students from your dashboard.",
    },
});
